import bridalSetAvif from "@/assets/images/bridal-set.avif";
import bridalSet400Avif from "@/assets/images/bridal-set-400w.avif";
import bridalSet400 from "@/assets/images/bridal-set-400w.webp";
import bridalSetImg from "@/assets/images/bridal-set.webp";
import coralSetAvif from "@/assets/images/coral-set.avif";
import coralSet400Avif from "@/assets/images/coral-set-400w.avif";
import coralSet400 from "@/assets/images/coral-set-400w.webp";
import coralSetImg from "@/assets/images/coral-set.webp";
import creamSetAvif from "@/assets/images/cream-set.avif";
import creamSet400Avif from "@/assets/images/cream-set-400w.avif";
import creamSet400 from "@/assets/images/cream-set-400w.webp";
import creamSetImg from "@/assets/images/cream-set.webp";
import dollBridalAvif from "@/assets/images/doll-bridal.avif";
import dollCommunionAvif from "@/assets/images/doll-communion.avif";
import dollCommunion400Avif from "@/assets/images/doll-communion-400w.avif";
import dollCommunion400 from "@/assets/images/doll-communion-400w.webp";
import dollCommunionImg from "@/assets/images/doll-communion.webp";
import dollBridal400Avif from "@/assets/images/doll-bridal-400w.avif";
import dollBridal400 from "@/assets/images/doll-bridal-400w.webp";
import dollBridalImg from "@/assets/images/doll-bridal.webp";
import ellaPortraitAvif from "@/assets/images/ella-portrait.avif";
import ellaPortrait400Avif from "@/assets/images/ella-portrait-400w.avif";
import ellaPortrait400 from "@/assets/images/ella-portrait-400w.webp";
import ellaPortraitImg from "@/assets/images/ella-portrait.webp";
import purpleDressAvif from "@/assets/images/purple-dress.avif";
import purpleDress400Avif from "@/assets/images/purple-dress-400w.avif";
import purpleDress400 from "@/assets/images/purple-dress-400w.webp";
import purpleDressImg from "@/assets/images/purple-dress.webp";
import yellowDressAvif from "@/assets/images/yellow-dress.avif";
import yellowDress400Avif from "@/assets/images/yellow-dress-400w.avif";
import yellowDress400 from "@/assets/images/yellow-dress-400w.webp";
import yellowDressImg from "@/assets/images/yellow-dress.webp";

export type PhotoVariant = {
  src: string;
  avif?: string;
  width: number;
};

export type SitePhoto = {
  src: string;
  avif: string;
  width: number;
  height: number;
  variants: PhotoVariant[];
};

function photo(
  src: string,
  avif: string,
  width: number,
  height: number,
  small: { src: string; avif: string; width: number },
): SitePhoto {
  return {
    src,
    avif,
    width,
    height,
    variants: [
      { src: small.src, avif: small.avif, width: small.width },
      { src, avif, width },
    ],
  };
}

export const photos = {
  coral: photo(coralSetImg, coralSetAvif, 680, 510, {
    src: coralSet400,
    avif: coralSet400Avif,
    width: 400,
  }),
  cream: photo(creamSetImg, creamSetAvif, 680, 510, {
    src: creamSet400,
    avif: creamSet400Avif,
    width: 400,
  }),
  purple: photo(purpleDressImg, purpleDressAvif, 680, 510, {
    src: purpleDress400,
    avif: purpleDress400Avif,
    width: 400,
  }),
  yellow: photo(yellowDressImg, yellowDressAvif, 680, 510, {
    src: yellowDress400,
    avif: yellowDress400Avif,
    width: 400,
  }),
  bridal: photo(bridalSetImg, bridalSetAvif, 680, 510, {
    src: bridalSet400,
    avif: bridalSet400Avif,
    width: 400,
  }),
  dollBridal: photo(dollBridalImg, dollBridalAvif, 680, 510, {
    src: dollBridal400,
    avif: dollBridal400Avif,
    width: 400,
  }),
  dollCommunion: photo(dollCommunionImg, dollCommunionAvif, 680, 680, {
    src: dollCommunion400,
    avif: dollCommunion400Avif,
    width: 400,
  }),
  ella: photo(ellaPortraitImg, ellaPortraitAvif, 531, 510, {
    src: ellaPortrait400,
    avif: ellaPortrait400Avif,
    width: 400,
  }),
} as const;

export function avifSrcSet(photoSrc: SitePhoto) {
  return photoSrc.variants
    .filter((variant) => variant.avif)
    .map((variant) => `${variant.avif} ${variant.width}w`)
    .join(", ");
}
